import { CalculationError } from '@hb/domain';
import { environment } from '@hb/hypotheken-berekening.environment';
import { ErrorService, MortgageCalculationError } from '@hb/services/error/error.service';

import { Component, inject, OnInit } from '@angular/core';

import { ApAnalyticsModule } from '@ap/analytics';
import { ApContentModule } from '@ap/content';
import { ApErrorModule } from '@ap/error';
import { ApNotificationComponent } from '@ap/notification';

@Component({
    selector: 'error-notification',
    templateUrl: './error-notification.component.html',
    styleUrls: ['./error-notification.component.scss'],
    standalone: true,
    imports: [ApAnalyticsModule, ApContentModule, ApErrorModule, ApNotificationComponent]
})
export class ErrorNotificationComponent implements OnInit {
    private readonly errorService = inject(ErrorService);

    error: MortgageCalculationError;

    ngOnInit(): void {
        this.errorService.error$().subscribe((error) => (this.error = error));
    }

    getMessage(error: MortgageCalculationError): string {
        if (error.message === CalculationError.INCOME_FINANCIAL_OBLIGATION) {
            return environment.mobile
                ? 'main.mortgage-calculation.calculation-error.financial-obligations.mobile'
                : 'main.mortgage-calculation.calculation-error.financial-obligations';
        } else if (error.message === CalculationError.EXTRA_ASSET) {
            return environment.mobile
                ? 'main.mortgage-calculation.calculation-error.extra-asset.mobile'
                : 'main.mortgage-calculation.calculation-error.extra-asset';
        }
        return 'main.mortgage-calculation.server-error';
    }

    getStatus(error: MortgageCalculationError): 'warning' | 'error' {
        if (error.isCalculationError) {
            return 'warning';
        }
        return 'error';
    }

    hideNotification() {
        this.error = null;
    }
}
